import { render, staticRenderFns } from "./imports.vue?vue&type=template&id=b7d67dda&scoped=true"
import script from "./imports.vue?vue&type=script&lang=js"
export * from "./imports.vue?vue&type=script&lang=js"
import style0 from "./imports.vue?vue&type=style&index=0&id=b7d67dda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d67dda",
  null
  
)

export default component.exports